import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useEffect, useState} from "react";

const tableConfig = {
  columns: [],
  activeColumns: ["name"],
  activeFilters: [],
  style: {
    height: "h-full"
  },
  rowSelection: false,
  meta: {
    id: 0,
    title: "",
    description: "Total Data",
    hasSearch: false,
    hasUpload: false,
    hasDownload: true,
    hasAdd: false,
    hasActions: false,
    hasCheckbox: false,
    hasFilter: false,
    hasFooter: true,
    hasHeader: true,
    hasPagination: true,
    hasCreate: false
  },
  url: {
    page: {},
    api: {}
  },
  actions: [],
  tabledatas: []
};
const mappedColumns = [
  {uid: "name", name: "Name", checkbox: false},
  {uid: "admissionNo", name: "Admission No", checkbox: false},
  {uid: "vehicleName", name: "Vehicle", checkbox: false},
  {uid: "routeName", name: "Route", checkbox: false},
  {uid: "bpLat", name: "Latitude", checkbox: false},
  {uid: "bpLng", name: "Longitude ", checkbox: false},
  {uid: "bpName", name: "Stop", checkbox: false}
];

const unmappedColumns = [
  {uid: "admissionNo", name: "Admission No", checkbox: false},
  {uid: "name", name: "Name", checkbox: false},
  {uid: "lat", name: "Latitude", checkbox: false},
  {uid: "lng", name: "Longitude ", checkbox: false}
];

const vehicleDataColumns = [
  {uid: "routeName", name: "Route", checkbox: false},
  {uid: "stops", name: "Stops", checkbox: false},
  {uid: "users", name: "Users", checkbox: false},
  {uid: "distance", name: "KMs", checkbox: false},
  {uid: "duration", name: "Travel Time", checkbox: false}
];
export const ViewOutputData = function ({
  exportData,
  selectedOption,
  vehicleTableData
}: {
  exportData: rpExportData | undefined;
  selectedOption: any;
  vehicleTableData: any;
}) {
  const [viewExportData, setViewExportData] = useState<any>([]);
  useEffect(() => {
    let tableConfigdatas = {
      ...tableConfig,
      columns:
        selectedOption === "option1"
          ? unmappedColumns
          : selectedOption === "option2"
            ? mappedColumns
            : selectedOption === "option3"
              ? vehicleDataColumns
              : [],
      meta: {
        ...tableConfig.meta,
        title:
          selectedOption === "option1"
            ? "Unmapped Users"
            : selectedOption === "option2"
              ? "Mapped Users"
              : selectedOption === "option3"
                ? "Vehicle Data"
                : ""
      },
      tabledatas:
        selectedOption === "option1"
          ? exportData?.unMappedUsers
          : selectedOption === "option2"
            ? exportData?.mappedUsers
            : selectedOption === "option3"
              ? vehicleTableData
              : []
    };
    setViewExportData(tableConfigdatas);
  }, [exportData, vehicleTableData, selectedOption]);
  return <>{viewExportData?.columns && <NeoAGgrid table={viewExportData} />}</>;
};
